// extracted by mini-css-extract-plugin
module.exports = {"reviews":"uw+r0gRw6eMgRXMqkkyN4Q==","reviewItem":"Ecya2kUDpcfAPCj2rTqRcQ==","guaranteeBlockContainer":"Ho7O-Kfog44UuM9sB4bUBw==","headerBlock":"wtEIHQki54CEga29SOal3Q=="};